module.exports = __webpack_public_path__ + "img/niews-7.d5d6fbc4.jpeg";